import "./dashboard-ui.css";

/**
 * Icon-led KPI tile used across the dashboard/report pages.
 *
 * @param {string} icon - mdi icon class suffix, e.g. "mdi-truck-delivery"
 * @param {string} color - bootstrap color keyword: primary|success|danger|warning|info|dark
 */
export default function StatCard({
  icon,
  color = "primary",
  label,
  sublabel,
  value,
  suffix,
  footer,
  loading = false,
}) {
  return (
    <div className={`card stat-card h-100 variant-${color}`}>
      <div className="card-body d-flex align-items-start">
        {icon && (
          <div className="stat-card-icon me-3">
            <i className={`mdi ${icon}`}></i>
          </div>
        )}
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <div className="stat-card-label">
            {label} {sublabel && <span className="stat-card-sublabel">&middot; {sublabel}</span>}
          </div>
          <h3 className="stat-card-value text-variant mt-1 mb-0">
            {loading ? (
              <span className="spinner-border spinner-border-sm" role="status">
                <span className="visually-hidden">Chargement...</span>
              </span>
            ) : (
              <>
                {value}
                {suffix && <span className="stat-card-suffix"> {suffix}</span>}
              </>
            )}
          </h3>
          {footer && <div className="stat-card-footer mt-1">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
